import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiCheck, FiMessageSquare, FiShield } from 'react-icons/fi';
import ThemeToggle from './ThemeToggle.jsx';
import logo from '../landing/assets/Novalink Solution full -R.png';
import '../styles/auth.css';

// Shared split layout for the pre-login pages (login, register, forgot/reset password, verify email).
// Left: always-dark brand panel (desktop only). Right: top bar + the page's form card.
export default function AuthShell({ children }) {
  return (
    <div className="auth-container">
      <aside className="auth-brand" aria-label="NovaBotX">
        <div className="auth-brand-glow" aria-hidden="true" />
        <div className="auth-brand-grid" aria-hidden="true" />

        <Link to="/" className="auth-brand-logo" aria-label="Novalink home">
          <img src={logo} alt="Novalink Solutions" />
        </Link>

        <div className="auth-brand-body">
          <span className="auth-kicker">NovaBotX™</span>
          <h2>
            Your enterprise knowledge, <span className="auth-grad-text">one question away</span>
          </h2>
          <p>
            Train a secure AI assistant on your documents and websites, then get instant,
            source-aware answers for your whole team.
          </p>
          <ul className="auth-brand-list">
            <li><span><FiCheck /></span> Answers grounded in your own content</li>
            <li><span><FiCheck /></span> Tenant isolation and role-based access</li>
            <li><span><FiCheck /></span> Set up in minutes, no code required</li>
          </ul>
        </div>

        <div className="auth-brand-preview" aria-hidden="true">
          <div className="auth-preview-msg is-user">How many leave days do new hires get?</div>
          <div className="auth-preview-msg is-bot">
            <span className="auth-preview-avatar"><FiMessageSquare /></span>
            <div>
              New hires get 18 days of paid leave per year.
              <small><FiShield /> HR Handbook 2026.pdf · p. 14</small>
            </div>
          </div>
        </div>

        <p className="auth-brand-foot">© {new Date().getFullYear()} Novalink Solutions</p>
      </aside>

      <main className="auth-main">
        <div className="auth-topbar">
          <Link to="/" className="auth-home-link">
            <FiArrowLeft aria-hidden="true" /> <span>Back to home</span>
          </Link>
          <Link to="/" className="auth-mobile-logo" aria-label="Novalink home">
            <img src={logo} alt="Novalink Solutions" />
          </Link>
          <ThemeToggle />
        </div>
        <div className="auth-main-inner">{children}</div>
      </main>
    </div>
  );
}
